import React, { useState, useEffect } from "react";
import "./Card.css";
import TOILET from "../assets/toilet-placeholder.jpeg";
import Stars from "./Stars";

const fullCollegeName = (acronym) => {
  const acronymMap = {
    CAS: "College of Arts and Sciences",
    CAFS: "College of Agriculture and Food Science",
    CDC: "College of Development Communication",
    CEM: "College of Economics and Management",
    CEAT: "College of Engineering and Agro-Industrial Technology",
    CFNR: "College of Forestry and Natural Resources",
    CHE: "College of Human Ecology",
    CPAD: "College of Public Affairs and Development",
    CVM: "College of Veterinary Medicine",
    GS: "Graduate School",
    SESAM: "School of Environmental Science and Management",
  };

  return acronymMap[acronym && acronym.toUpperCase()] || acronym;
};

const Card = ({ data, activeButton }) => {
  const { _id, college, building, main_photo, average_rating, recent_review } =
    data;
  const [reviewCount, setReviewCount] = useState(0);
  const [reviewSpotlight, setReviewSpotlight] = useState("");

  const API_LINK = `https://uplbidet-api.vercel.app/api/reviews/cr/${_id}`;

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(API_LINK);
        const reviews = await response.json();

        if (Array.isArray(reviews)) {
          setReviewCount(reviews.length);

          switch (activeButton) {
            case "BEST":
              const bestReview = reviews.reduce((max, review) =>
                review.likes > max.likes ? review : max
              );
              setReviewSpotlight(bestReview.comment);
              break;
            case "WORST":
              const worstReview = reviews.reduce((min, review) =>
                review.likes < min.likes ? review : min
              );
              setReviewSpotlight(worstReview.comment);
              break;
            case "RECENT":
              const recentReview = reviews.find(
                (review) => review._id === recent_review
              );
              setReviewSpotlight(
                recentReview
                  ? recentReview.comment
                  : "Be the first to write a review!"
              );
              break;
            default:
              break;
          }
        }
      } catch (err) {
        console.error("Error fetching reviews: ", err);
      }
    };

    fetchReviews();
  }, [API_LINK, activeButton]);

  const collegeImage = require(`../assets/colleges/${college.toUpperCase()}.png`);

  const isExternalImage =
    main_photo &&
    (main_photo.startsWith("https://") || main_photo.startsWith("data:image"));
  const photoSource = isExternalImage ? main_photo : TOILET;

  return (
    <>
      <div className="card">
        <div className="header">
          <div className="image">
            <img src={collegeImage} alt="college_logo" />
          </div>
          <div className="names">
            <div className="building-name">{building}</div>
            <div className="college-name">
              {fullCollegeName(college).toUpperCase()}
            </div>
          </div>
        </div>
        <div className="main-image">
          <img src={photoSource} alt="" />
        </div>
        <div className="summary">
          <div className="preview">
            {console.log(reviewSpotlight.length)}
            {reviewSpotlight.length === 0
              ? "Be the first to write a review!"
              : reviewSpotlight}
          </div>
          <div className="review">
            <Stars averageRating={average_rating} />
            <div className="stars-rating">
              <span>
                {average_rating.toFixed(1)}/5 ({reviewCount} reviews)
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
